export const FLASH_CARD_ROUTES = {
  start: '/flash-cards',
  study: '/flash-cards/study',
  list: '/flash-cards/list',
};
